import { render } from "./waiters_component.vue?vue&type=template&id=68cd8bb3&scoped=true"
import script from "./waiters_component.vue?vue&type=script&lang=js"
export * from "./waiters_component.vue?vue&type=script&lang=js"

import "./waiters_component.vue?vue&type=style&index=0&id=68cd8bb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cd8bb3"]])

export default __exports__